<template>
  <section class="block-countdown">
    <div class="container">
      <div class="block-countdown__title-wrapper">
        <div class="block-countdown__icon">⏱</div>
        <h2 class="block-countdown__title">
          ТОРОПИТЕСЬ!<br/>
          Акция закончится через:
        </h2>
      </div>
      <block-clock></block-clock>
      <button
        @click="getCall({ type: 'sale', form: 'countdown' })"
        class="block-countdown__btn button_theme_white"
      >
        Зафиксировать условия
      </button>
    </div>
  </section>
</template>

<script>
import Mixin from "../common/mixin";

import BlockClock from "./block-clock.vue";

export default {
  name: "block-countdown",
  components: { BlockClock },
  mixins: [Mixin],
  methods: {
    handleAgreement() {
      this.$emit("getAgreement");
    },
    handleCallback(data) {
      this.$emit("callBack", data);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";
.block-countdown {
  background: linear-gradient(180deg, #092333 45.31%, #1c465f 100%);
  padding: 2em 0;
  color: #fff;
  font-size: 20px;

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title-wrapper {
    display: flex;
    align-items: center;
    gap: 1em;
  }

  &__icon {
    font-size: 3.15em;
    font-weight: bold;
    color: $primary;
  }

  &__title {
    font-weight: 700;
    font-size: 1.3em;
  }

  &__btn {
    max-width: 258px;
    height: 50px;
  }
}

@media (max-width: 1200px) {
  .block-countdown {
    font-size: calcFontSize(10, 20, 640, 1200);

    .container {
      flex-direction: column;
    }

    &__title {
      margin-bottom: 0.5em;
    }

    &__btn {
      margin-top: 30px;
    }
  }
}

@media (max-width: 640px) {
  .block-countdown {
    padding: 25px 0 33px 0;
    font-size: calcFontSize(13, 20, 360, 640);

    &__btn {
      max-width: 100%;
    }
  }
}
</style>
